/**
 * Shared 2D geometry helpers used by annotation hit-testing.
 *
 * These operate on plain numeric coordinates in image-pixel space and have
 * no dependency on the annotation object hierarchy.
 */

/** Squared distance between two points. Avoids a sqrt when comparing to a squared threshold. */
export function distSq(x1: number, y1: number, x2: number, y2: number): number {
    return (x1 - x2) ** 2 + (y1 - y2) ** 2;
}

/** Shortest distance from a point to a line segment. */
export function pointToSegmentDist(
    px: number,
    py: number,
    ax: number,
    ay: number,
    bx: number,
    by: number
): number {
    const dx = bx - ax;
    const dy = by - ay;
    const lenSq = dx * dx + dy * dy;
    if (lenSq === 0) return Math.sqrt(distSq(px, py, ax, ay));

    let t = ((px - ax) * dx + (py - ay) * dy) / lenSq;
    t = Math.max(0, Math.min(1, t));
    const projX = ax + t * dx;
    const projY = ay + t * dy;
    return Math.sqrt(distSq(px, py, projX, projY));
}
